<template>
    <v-container fluid class="">
        <v-card flat >

            <v-row class="mb-2 mt-6 mb-5">

                <v-col :cols='isMobile ? 12 : 6' class="d-flex flex-column justify-center align-center">

                    <v-card-title class="display-1 d-flex flex-column justify-center align-center cyan--text font-weight-bold mt-n8"> 
                        {{$t('impressions_map')}} 
                    </v-card-title>

                    <map-cluster class="map-cluster" :mapData="mapData" :heatData="heatData" :mapType="mapType" />

                    <v-btn class="btn-map-change"  @click="changeMap" color="#4ec5c1" dark absolute bottom left small>
                        <span> {{$t('change_map')}} </span>
                        <v-icon> mdi-sync </v-icon>
                    </v-btn>

                </v-col>

                <v-col :cols='isMobile ? 12 : 6'>

                    <v-card flat>

                        <v-card-title class="mytable d-flex flex-column justify-center align-center cyan--text font-weight-bold mt-n8"> {{$t('dash_overview.table_city')}} </v-card-title>

                        <v-data-table class="table-cities" hide-default-header :headers='headers2' :items="tableData" :sort-by="['value']" :sort-desc="[true]">

                            <template v-slot:header="props">

                                <thead>

                                    <tr>
                                        <th>
                                            <div class="header-text text-center"> {{props.props.headers[0].text}} </div>
                                        </th>
                                        <th >
                                            <div class="header-text text-center"> {{props.props.headers[1].text}} </div>
                                        </th>
                                    </tr>

                                </thead>

                            </template>

                            <template v-slot:item="props">

                                <tr>
                                    <td><div class="row-text-1 deep-orange--text text-center">{{props.item.city}} </div></td>
                                    <td><div class="row-text-2 deep-orange--text text-center">{{props.item.value}} </div></td>
                                </tr>

                            </template>

                        </v-data-table>

                    </v-card>

                </v-col>

            </v-row>

        </v-card>
    </v-container>
</template>

<script>

import vueI18n from '../../../plugins/vue-i18n'
import MapCluster from './MapCluster.vue'

export default {

    components: { MapCluster },

    name: 'MapContainer',

    data() {
        return {

            mapCenter: { lat: -17.576493, lng: -48.527000 },
            mapZoom: 4,
            mapType: 'heatmap'

        }
    },

    props: ['mapData', 'tableData', 'heatData'],

    computed: {

        headers2() {

            return [
                {
                    text: vueI18n.t('cities'),
                    value: 'city'
                },
                {
                    text: vueI18n.t('users'),
                    value: 'value'
                },
            ]
        },

    },

    methods: {

        changeMap() {

            if (this.mapType === 'cluster') this.$nextTick(() => { this.mapType = 'heatmap' })

            if (this.mapType === 'heatmap') this.$nextTick(() => { this.mapType = 'cluster' })

        },
    },

}

</script>

<style scoped>

.card {

    border-style: solid;
    border-color: #3fbdbd;
    border-radius: 30px;
    border-width: 3px
}

.btn-map-change {

}

.map-container {

    border-style: solid;
    border-color: #3fbdbd;
    border-radius: 5px !important;

}

.nav {

    width: 95% !important;

}

th {

    color: #3fbdbd;
    background-color: #3fbdbd;

}

.header-text {

    color: white;
    font-size: 20px;
    

}

.row-text-1 {

    font-size: 16px;
    font-weight: bold;

}

.row-text-2 {

    font-size: 16px;
    font-weight: bold;

}

tr:nth-child(even) {

    background: rgb(236, 235, 235)
}

tr:nth-child(odd) {

    background: #FFF
}

</style>